/**
 * orga app | api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UploadResponse { 
    upload_id?: string;
    user_id?: string;
    file_name?: string;
    content_type?: string;
    upload_date_utc?: string;
    folder_name?: string;
}

